import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Response} from '@angular/http';

import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';

import {Commission} from './commission.model';
import {CommissionPopupService} from './commission-popup.service';
import {CommissionService} from './commission.service';
import {CALENDAR_FR} from '../../shared/calendar/calendar.constants';

@Component({
    selector: 'jhi-commission-dialog',
    templateUrl: './commission-dialog.component.html'
})
export class CommissionDialogComponent implements OnInit {

    campagneId: number;
    commission: Commission;
    commissions: Commission[];
    authorities: any[];
    isSaving: boolean;
    createCommission = false;
    fr: any;
    isCommissionValid = Commission.isCommissionValid;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private commissionService: CommissionService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['campagne', 'commission']);
    }

    ngOnInit() {
        this.fr = CALENDAR_FR;
        this.isSaving = false;
        this.authorities = ['ROLE_SYSTEM', 'ROLE_ADMIN'];
        this.commissionService.query().subscribe(
            (res: Response) => {
                const commissions: Commission[] = res.json();

                // On filtre pour n'afficher que les commissions avec une date > (now - 3 mois)

                const now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth() - 3;
                if(month < 0) {
                    month += 12;
                    year -= 1;
                }
                this.commissions = commissions.filter(commission => commission.dateCommission > new Date(year, month, now.getDate()));
            },
            (res: Response) => this.onError(res.json())
        );
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    createCommissionButton() {
        this.createCommission = true;
    }

    selectCommission(commission) {
        this.onSaveSuccess(this.commissionService.convertHeures(commission));
    }

    save() {
        this.isSaving = true;
        if (this.commission.id !== undefined) {
            this.commissionService.update([this.commission])
                .subscribe(
                    (res: Commission[]) => this.onSaveSuccess(res[0]),
                    (res: Response) => this.onSaveError(res.json())
                );
        } else {
            this.commissionService.create(this.commission)
                .subscribe(
                    (res: Commission) => this.onSaveSuccess(res),
                    (res: Response) => this.onSaveError(res.json())
                );
        }
    }

    private onSaveSuccess (result: Commission) {
        this.eventManager.broadcast({ name: 'campagneCommissionsModification', content: result});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'jhi-commission-popup',
    template: ''
})
export class CommissionPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private commissionPopupService: CommissionPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            let campagneId = params['campagneId'];
            if ( params['id'] ) {
                this.modalRef = this.commissionPopupService
                    .open(CommissionDialogComponent, campagneId, params['id']);
            } else {
                this.modalRef = this.commissionPopupService
                    .open(CommissionDialogComponent, campagneId);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission-dialog.component.ts